export default [
  {
    path: 'scanLog',
    name: 'laborManagement.scanLog',
    meta: {
      title: 'Scan Log',
    },
    redirect: '/wms-labormanagement/scanLog',
    // component: () => import('@/views/labor-management/scan-log/index.vue'),
  },
];
